const template = require('./filter_deselect.html.slim')
declare var angular

export class FilterDeselect {
  static $inject = ['$rootScope']

  constructor(private $rootScope) {}

  public deselectFilters(): void {
    this.$rootScope.$broadcast('deselectFilterTriggered')
  }
}

angular.module('wbComponents').directive('wbFilterDeselect', function() {
  return {
    restrict: 'E',
    controller: FilterDeselect,
    controllerAs: 'ctrl',
    bindToController: true,
    scope: {
      query: '@',
      list: '='
    },
    templateUrl: template
  }
})
